import * as z from 'zod';
import { DayJsSchema, EntityId, Tag } from './base-schemas';
import { isoDateToDayJs, isoDateTimeToDayJs } from './base-codecs';
import { CustomerModel, EnrichedCustomer } from './Customer';
import { PositionModel } from './Position';
import { CategoryModel } from './Category';
import { ReservationModel } from './reservations/Reservation';
export const BookingModel = z.object({
    _tag: Tag('BookingModel'),
    id: EntityId,
    booking_number: z.string(),
    type: z.enum(['regular', 'season']),
    check_in: isoDateToDayJs,
    check_out: isoDateToDayJs,
    expected_arrival_time: z.string().nullable(),
    category_id: EntityId,
    season_id: EntityId.nullable(),
    cancellation_policy_id: EntityId.nullable(),
    lodging_type_id: EntityId.nullable(),
    customer_id: EntityId,
    position_id: EntityId.nullable(),
    created_at: isoDateTimeToDayJs.nullable(),
    updated_at: isoDateTimeToDayJs.nullable(),
    deleted_at: isoDateTimeToDayJs.nullable(),
    checked_in_at: isoDateTimeToDayJs.nullable(),
    checked_out_at: isoDateTimeToDayJs.nullable(),
    auto_checkout_at: isoDateTimeToDayJs.nullable(),
    confirmed_at: isoDateTimeToDayJs.nullable(),
    draft_expires_at: isoDateTimeToDayJs.nullable(),
    remarks: z.string().nullable(),
    adults: z.number().nullable(),
    children: z.number().nullable(),
    dogs: z.number().nullable(),
    booking_group_id: EntityId.nullable(),
    channel_id: EntityId.nullable(),
    is_customer_selected_position: z.boolean(),
    bookvisit_metadata: z.unknown().nullable(),
    // Attributes
    electricity_status: z.string().nullable().optional(),
    // title: z.string().nullable(), // Jag vet inte var dom här kom från
    // daysFormatted: z.string().nullable(), // Jag vet inte var dom här kom från
    // subtitle: z.string().nullable(), // Jag vet inte var dom här kom från
    is_draft: z.boolean(),
    bookvisit_information: z.string().nullable(),
    external_bookvisit_source: z.any().nullable(),
    // Relations (when loaded)
    get customer() { return CustomerModel.nullish(); },
    get position() { return PositionModel.nullish(); },
    get category() { return CategoryModel.nullish(); },
    season: z.object({
        id: EntityId,
        name: z.string()
    }).nullish(),
    cancellationPolicy: z.object({
        id: EntityId,
        name: z.string()
    }).nullish(),
    lodgingType: z.object({
        id: EntityId,
        name: z.string()
    }).nullish(),
    channel: z.object({
        id: EntityId,
        readable_name: z.string().nullable(),
        icon: z.string().nullable()
    }).nullish()
});
export const EnrichedBooking = BookingModel.extend({
    _tag: Tag('EnrichedBooking'),
    isEnriched: z.literal(true),
    title: z.string().optional(),
    daysFormatted: z.string().optional(),
    subtitle: z.string().optional(),
    check_in: DayJsSchema,
    check_out: DayJsSchema,
    created_at: DayJsSchema,
    updated_at: DayJsSchema,
    deleted_at: DayJsSchema.nullable(),
    checked_in_at: DayJsSchema.nullable(),
    checked_out_at: DayJsSchema.nullable(),
    auto_checkout_at: DayJsSchema.nullable(),
    confirmed_at: DayJsSchema.nullable(),
    draft_expires_at: DayJsSchema.nullable(),
    // Relations (when loaded)
    get customer() { return EnrichedCustomer.nullish(); },
    get reservations() { return ReservationModel.array().nullish(); },
    lodgingType: z.object({}).nullish(),
    season: z.object({}).nullable().optional(),
    position: z.object({}).nullable().optional(),
    category: z.object({}).nullable().optional(),
    channel: z.object({
        id: EntityId,
        readable_name: z.string().nullable(),
        icon: z.string().nullable()
    }).nullish(),
    cancellationPolicy: z.object({}).nullish()
});
export const BookingResource = z.object({
    id: EntityId,
    booking_number: z.string(),
    position_id: EntityId.nullable(),
    check_in: isoDateToDayJs.nullable(),
    check_out: isoDateToDayJs.nullable(),
    checked_in_at: isoDateTimeToDayJs.nullable(),
    checked_out_at: isoDateTimeToDayJs.nullable(),
    customer: z.object({
        id: EntityId,
        name: z.string(),
        given_name: z.string().nullable(),
        surname: z.string().nullable(),
        email: z.email().nullable(),
        phone: z.string().nullable()
    }).nullish(),
    adults: z.number().nullable(),
    children: z.number().nullable(),
    dogs: z.number().nullable(),
    created_at: isoDateTimeToDayJs.nullable(),
    updated_at: isoDateTimeToDayJs.nullable()
});
